
import React from "react";
import { Route, Routes as ReactRoutes, Navigate } from "react-router-dom";


import Index from "./Partials/Universal/Dashboard/Index";
import IndexHr from "HRMS/HRDashboard/IndexHr";
import RoomStatus from "./Partials/Universal/RoomBook/RoomStatus/RoomStatus";

import TuningRoutes from "./TuningRoutes/TuningRoutes";
import TuningDynamicRoutes from "./TuningRoutes/TuningDynamicRoutes";

import HotelRoutes from "./HotelRoutes/HotelRoutes";
import HotelDynamicRoutes from "./HotelRoutes/HotelDynamicRoutes";

import HumanResourceRoutes from "./HumanResourceRoutes/HumanResourceRoutes";
import HumanResourceDynamicRoutes from "./HumanResourceRoutes/HumanResourceDynamicRoutes";
import { useSelector } from "react-redux";

import NoPageFound from "Tuning/Pages/Authentication/NoPageFound";

const Routes = () => {
  const menuList = useSelector((state) => state.menulist?.menulist || []);
  const anyLoading = menuList.length === 0;

  return (
    <ReactRoutes>
      {/* Tuning Routes */}
      {TuningDynamicRoutes()}
      {TuningRoutes()}

      {/* Hotel Routes */}
      {HotelDynamicRoutes()}
      {HotelRoutes()}

      {/* Human Resource Routes */}
      {HumanResourceDynamicRoutes()}
      {HumanResourceRoutes()}

      {/* Common Routes */}
      <Route exact path="/" element={<Navigate to="/index" replace />} />

      <Route exact path="/room-status" element={<RoomStatus />} />
      <Route exact path="/index" element={<Index />} />
      <Route exact path="/index-hr" element={<IndexHr />} />

      {/* Global Not Found Catch-all: show only when menu loading finished */}
      {!anyLoading && <Route path="*" element={<NoPageFound />} />}
    </ReactRoutes>
  );
};

export default Routes;